module.exports = __webpack_public_path__ + "media/6.b487d017.mp3";